export const REGISTRADO = 1;
export const ANULADO = 2;
export const APROBADO = 3;
export const RECHAZADO = 4;
export const IMPORTADO = 5;
export const IMPORTADO_PARCIAL = 6;